import React from 'react'

import { useDataDog } from './useDataDog'

export function Scripts() {
  useDataDog()
  return (
    <>
      <meta charSet="utf-8" />
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <meta content="#000000" name="theme-color" />
      <title>Mission Control</title>
    </>
  )
}
